import { defineComponent, onMounted } from 'vue';
import { SeoStructuredData } from "@/study-search/presentation/components/SeoStructuredData/SeoStructuredData.class";

export default defineComponent({

	setup: () => {

		const component = new SeoStructuredData();
		onMounted(component.mounted.bind(component));

		return {
			structuredData: component.structuredData,
		};
	},
});
